import { NgModule } from '@angular/core';
import { ChangeHistoryModule } from '@app/shared/components/change-history/change-history.module';
import { PopoverService } from '@app/shared/components/popover/popover.service';
import { UnitListItemsModule } from '@app/shared/components/unit-list-items-setup/unit-list-items.module';
import { DialogService } from './core/services';
import { AccountCopyModule } from './modules/fund-management/account-copy/account-copy.module';
import { VendorsModule } from './modules/fund-management/accounts-payable/vendors/vendors.module';
import { CashManagementModule } from './modules/fund-management/cash-management/cash-management.module';
import { FundManagementModule } from './modules/fund-management/fund-management.module';
import { ManageAccountsModule } from './modules/fund-management/manage-accounts/manage-accounts.module';
import { SystemSettingsSystemSetupModule } from './modules/system-settings/system-setup/system-setup.module';
import { LinqFormsModule } from './shared/forms/forms.module';
/**
 * Allow AngularJS to access Angular modules, services, etc
 */
@NgModule({
	declarations: [],
	imports: [
		AccountCopyModule,
		CashManagementModule,
		ChangeHistoryModule,
		FundManagementModule,
		VendorsModule,
		LinqFormsModule,
		ManageAccountsModule,
		SystemSettingsSystemSetupModule,
		UnitListItemsModule,
	],
	providers: [PopoverService, DialogService],
	bootstrap: [],
})
export class DowngradeModule {}
